// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const PenOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M6.52 11.18l8.72-8.72a1.03 1.03 0 011.46 0l1.1 1.1a1.03 1.03 0 010 1.46l-8.72 8.73c-.27.27-.61.46-.98.54l-1.7.4a.69.69 0 01-.83-.82l.4-1.7c.09-.37.28-.71.55-.99v0z","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M14.57 5.67l-6.76 6.76","stroke-width":".5","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M6.68 10.61l2.74 2.74","stroke-width":"1.5","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M13.61 4.08l2.57 2.57M19.45 15.4a4.17 4.17 0 00-6.87.2l-2.02 3.13a3.13 3.13 0 01-5.71-2.18l.04-.3","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","stroke":"currentColor"}}]},"name":"pen","theme":"outlined"};

const PenOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={PenOutlinedSvg} />;
  PenOutlined.displayName = 'PenOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(PenOutlined);
